import { FileLoader,  UploadAdapter, UploadResponse } from '@ckeditor/ckeditor5-upload';
import { Subscription } from 'rxjs';

import { CKUploadService } from '../service/ck-upload.service';


export class CKUploadAdapter implements UploadAdapter {

    public loader: FileLoader;
    public uploadService: CKUploadService;
    public uploadRequest: Subscription;

    constructor(
        loader: FileLoader,
        uploadService: CKUploadService
    ) {
        this.loader = loader;
        this.uploadService = uploadService;
    }

    /**
     * Starts the upload process.
     *
     * @see module:upload/filerepository~UploadAdapter#upload
     */
    public upload(): Promise<UploadResponse> {
        return this.loader.file
            .then(file => new Promise((resolve, reject) => {
                this.unsubscribe();
                this.uploadRequest = this.uploadService.handleFileInput(file).subscribe({
                    next: (url) => resolve({ default: url }),
                    error: (error) => reject(error)
                });
            }));
    }

    public abort(): void {
        this.unsubscribe();
    }

    public unsubscribe(): void {
        if (this.uploadRequest) {
            this.uploadRequest.unsubscribe();
            this.uploadRequest = null;
        }
    }
}
